import { createSSRApp, nextTick } from 'vue';
import App from './App.vue';
import pinia from './store';

import CImg from '@/components/c-img/index.vue';
import LoadMore from '@/components/load-more/index.vue';
import Money from '@/components/money/index.vue';
import Overlay from '@/components/overlay/index.vue';
import PageProvider from '@/components/page-provider/index.vue';
import Popup from '@/components/popup/index.vue';

// #ifdef H5
import vTap from '@/directives/tap';
// #endif

import uniMatomo from './services/matomo';
import errorManager, { ErrorManagerEntryType } from './utils/errorManager';

console.log('[Matomo 实例]', uniMatomo.getMatomo());

export function createApp() {
  const app = createSSRApp(App);

  app.use(pinia);

  app
    .component('PageProvider', PageProvider)
    .component('CImg', CImg)
    .component('Money', Money)
    .component('Popup', Popup)
    .component('LoadMore', LoadMore)
    .component('Overlay', Overlay);

  // #ifdef H5
  app.directive('tap', vTap);
  // #endif

  app.config.errorHandler = (err: any, vm: any, info: any) => {
    nextTick(async () => {
      errorManager.report(ErrorManagerEntryType.vueComponent, {
        message: `组件：${vm.$.vnode.type.__file} \n发生错误：${err} \n所在生命周期：${info}`,
      });

      console.log(`[vue-error 组件]`, vm.$.vnode.type.__file);
      console.log(`[vue-error 所在生命周期]`, info);
      console.log(`[vue-error 信息]`, err);
    });
  };

  return {
    app,
  };
}
